import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles } from "lucide-react";

function timeAgo(iso) {
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

/**
 * Compact single-line rolling ticker of recent real signups.
 * Sits directly under the "X joined this week" counter on the hero for extra live-feel.
 */
export default function SignupTicker() {
  const [events, setEvents] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    let alive = true;
    const load = () =>
      api
        .get("/stats/activity")
        .then((r) => {
          if (!alive) return;
          const signups = (r.data.events || []).filter((e) => e.type === "signup").slice(0, 8);
          setEvents(signups);
        })
        .catch(() => {});
    load();
    const t = setInterval(load, 45000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  useEffect(() => {
    if (events.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % events.length), 4000);
    return () => clearInterval(t);
  }, [events.length]);

  if (!events.length) return null;
  const ev = events[idx];

  return (
    <div
      data-testid="signup-ticker"
      className="mb-6 inline-flex items-center gap-3 max-w-full"
    >
      <Sparkles className="w-3.5 h-3.5 text-amber-500 shrink-0" />
      <div
        key={idx}
        data-testid="signup-ticker-event"
        className="text-xs uppercase tracking-widest text-neutral-400 truncate animate-in fade-in slide-in-from-right-2 duration-500"
      >
        <span className="text-neutral-100 font-bold">{ev.text}</span>
        <span className="mx-2 text-neutral-700">·</span>
        <span className="text-amber-500">{timeAgo(ev.at)}</span>
      </div>
    </div>
  );
}
